import React from 'react';
import { Button, Tooltip } from 'antd';
import { LaborExtra as LaborExtraResponse } from '@/DTOS/LaborExtra/Response/LaborExtra';
import { EditOutlined} from '@ant-design/icons';

export const LaborExtraColumn = (
  handleEdit: (record: LaborExtraResponse) => void
) => [
  {
    title: 'Labor Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Nume',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Status',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 200,
    render: (isActive: boolean) => (isActive ? 'Activ' : 'Inactiv'),
  },
  {
    title: 'Actiune',
    dataIndex: '',
    key: 'actions',
    render: (record: LaborExtraResponse) => (
      <Tooltip title= 'Modifica'>
      <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
      </Tooltip>
    ),
    width: 120,
    fixed:'right'
  },
];
